const Immersive3dTourStatus = {
  IN_CREATION: 0,
  PROCESSING: 1,
  POST_PROCESSING: 2,
  DELIVERED: 3,
  NOT_IN_CREATION: 4,
  DENIED: 5,
  INACTIVE: 6,
};

export default Immersive3dTourStatus;

/**
 * Meant to be used with a dropdown list component
 */
export const StatusOptions = [
  { key: "all", translationText: "immersive3dTourPanelConstants:all", value: "" },
  {
    key: "inCreation",
    translationText: "immersive3dTourPanelConstants:inCreation",
    value: Immersive3dTourStatus.IN_CREATION,
  },
  {
    key: "processing",
    translationText: "immersive3dTourPanelConstants:processing",
    value: Immersive3dTourStatus.PROCESSING,
  },
  {
    key: "postProcessing",
    translationText: "immersive3dTourPanelConstants:postProcessing",
    value: Immersive3dTourStatus.POST_PROCESSING,
  },
  {
    key: "delivered",
    translationText: "immersive3dTourPanelConstants:delivered",
    value: Immersive3dTourStatus.DELIVERED,
  },
  {
    key: "notInCreation",
    translationText: "immersive3dTourPanelConstants:notInCreation",
    value: Immersive3dTourStatus.NOT_IN_CREATION,
  },
  { key: "denied", translationText: "immersive3dTourPanelConstants:denied", value: Immersive3dTourStatus.DENIED },
  { key: "inactive", translationText: "immersive3dTourPanelConstants:inactive", value: Immersive3dTourStatus.INACTIVE },
];
